import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


import { AppComponent } from './app.component';


import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ScvEmployeeService} from '../scv-topbar/scv.employee.service'

import {AppRoutingModule} from './app-routing.module'
import { LoginComponent } from './login/login.component'
import { AppConfig } from './app.config';
import { APP_INITIALIZER } from '@angular/core';
import { environment } from '../environments/environment';
import { ScvSharedModule } from './shared/scv-shared.module';
import { ScvTopBarComponent } from 'src/scv-topbar/scv.topbar.component';
import { ScvMenuComponent } from 'src/scv-menu/scv.menu.component';
import { FooterComponent } from 'src/app/shared/layout/scv-footer/footer.component';
import { Configuration } from './app.constants';
import { AuthService } from './services/auth.service';
import { MessageService,ConfirmationService} from 'primeng/primeng';
import { OnScreenMessageService } from './services/onScreenMessage/onScreenMessage.sevice';
import { AvatarModule } from 'ngx-avatar';
import { CommonService } from './services/common.service';
import { ApiInterceptor } from 'src/http.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
const avatarColors = ["#FFB6C1", "#2c3e50", "#95a5a6", "#f39c12", "#1abc9c"];
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ConsentService } from './dashboard/consent-form/consent.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ScvTopBarComponent,
    ScvMenuComponent,
    FooterComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpModule,
    AppRoutingModule,
    ScvSharedModule,
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: true
        }),
    AvatarModule.forRoot({
      colors: avatarColors
    }),
    Ng4LoadingSpinnerModule.forRoot()
  ],
  providers: [
    ScvEmployeeService,
    AuthService,
    AppConfig,
    Configuration,
    MessageService,
    CommonService,
    ConsentService,
    ConfirmationService,
    OnScreenMessageService,
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true 
    },
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true}],
  bootstrap: [AppComponent]
})
export class AppModule { }
